import {noop} from "@hosttools/core/constant";
import {createContext} from "react";

import type {IToastService} from "../../components/ui/toast";

export type ToastOptions = {
    placement: "top right" | "bottom";
    duration?: number;
    render: (props: {id: string}) => React.ReactNode;
};

export type ToastAPI = {
    show: (options: ToastOptions) => void;
    close: (toastId: string) => void;
    closeAll: () => void;
    success: (title: string, duration?: number) => void;
    info: (title: string) => void;
    warning: (title: string) => void;
    error: (title: string) => void;
};

export type ToastContextType = {
    toast: ToastAPI;
    setToast: (toast: IToastService) => void;
};

const defaultValue: ToastContextType = {
    toast: {
        show: noop,
        close: noop,
        closeAll: noop,
        success: noop,
        info: noop,
        warning: noop,
        error: noop
    },
    setToast: noop
};

const ToastContext = createContext<ToastContextType>(defaultValue);

export default ToastContext;
